// src/pages/CancelPage.jsx
import React from 'react';

export default function CancelPage() {
  return (
    <div className="text-center p-8">
      <h1 className="text-3xl font-bold mb-4 text-red-600">Payment Cancelled</h1>
      <p className="mb-4">Your payment was not completed. You can try again.</p>
      <a href="/meatgroup" className="text-blue-500 underline">Return to Group</a>
    </div>
  );
}

